export const smoothScrollTo = (position: number, callback?: () => void) => {
    const endPosition = parseInt(position.toFixed());
    let completed = false;

    const onScroll = () => {
        if (Math.floor(window.pageYOffset) === endPosition) {
            window.removeEventListener('scroll', onScroll);
            completed = true;
            callback && callback();
        }
    };

    setTimeout(() => {
        if (!completed) {
            window.removeEventListener('scroll', onScroll);
            callback && callback();
        }
    }, 1000);

    window.addEventListener('scroll', onScroll);
    onScroll();
    window.scrollTo({
        top: endPosition,
        behavior: 'smooth'
    });
};
